import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  template: `<h1>
  <ng-content></ng-content>
</h1>`
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
